import { memo } from 'react';
import { formatTimer } from 'utils';
import { MediaFileProps } from './media-file.types';
import { Badge } from 'components/ui';
import { ImageOrVideoWrapper } from '../styles';
import { Icons } from 'assets';
import { useMedia } from 'components/media/media.context';

type VideoFilProps = MediaFileProps & {
  registerVideo?: (el: HTMLVideoElement | null) => void;
};

export const VideoFile = memo((props: VideoFilProps) => {
  const { file, registerVideo, view = 'full' } = props;
  const { dispatch } = useMedia();

  const handleError = () => {
    dispatch({
      type: 'MEDIA/MEDIA_ERROR',
      id: file.id,
    });
  };

  if (file.type !== 'video') {
    return null;
  }

  if (view === 'thumbnail') {
    return (
      <ImageOrVideoWrapper>
        <img src={file.poster} alt="" loading="lazy" onError={handleError} />

        {file.mediaStatus === 'loaded' && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Badge icon="Play" mode="gray">
              {formatTimer(file.duration ?? 0, false)}
            </Badge>
          </div>
        )}
      </ImageOrVideoWrapper>
    );
  }

  return (
    <ImageOrVideoWrapper>
      <video
        ref={registerVideo}
        src={file.url}
        poster={file.poster}
        preload="none"
        crossOrigin="anonymous"
        controls
        playsInline
        onError={handleError}
      />
    </ImageOrVideoWrapper>
  );
});
